/**
 * Beacon API transport strategy
 * Priority: Medium (good for page unload)
 * Best for fire-and-forget scenarios
 * Note: Cannot send custom headers - will be skipped if headers are required
 */

import type { TransportStrategy, TransportPayload } from './TransportStrategy.js';

export class BeaconTransport implements TransportStrategy {
  name = 'beacon';
  priority = 50;

  isAvailable(): boolean {
    return typeof navigator !== 'undefined' && 'sendBeacon' in navigator;
  }

  async send(payload: TransportPayload): Promise<void> {
    const sent = this.sendSync(payload);
    if (!sent) {
      throw new Error('sendBeacon returned false (queue full or data too large)');
    }
  }

  sendSync(payload: TransportPayload): boolean {
    // Beacon API works best when auth is in the payload body, not headers
    const blob = new Blob([JSON.stringify(payload.data)], { type: 'application/json' });
    return navigator.sendBeacon(payload.endpoint, blob);
  }
}

